/* Sprint E — Reusable readiness chip.
 *
 * Color-coded chip used by DiscoveryWizard for sub-scores and
 * per-stage statuses. Soft guidance only — even the "blocked"
 * variant only means "not ready"; existing Run buttons stay
 * untouched.
 */
import { CheckCircle2, AlertTriangle, Circle } from "lucide-react";

const STATUS_STYLES = {
    ready: {
        cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-200",
        icon: CheckCircle2,
        label: "Ready",
    },
    proceed_with_warnings: {
        cls: "border-amber-500/40 bg-amber-500/10 text-amber-200",
        icon: AlertTriangle,
        label: "Proceed with warnings",
    },
    blocked: {
        cls: "border-rose-500/40 bg-rose-500/10 text-rose-200",
        icon: Circle,
        label: "Not ready",
    },
};

function scoreColor(score) {
    if (score >= 70) return "border-emerald-500/40 bg-emerald-500/10 text-emerald-200";
    if (score >= 40) return "border-amber-500/40 bg-amber-500/10 text-amber-200";
    return "border-rose-500/40 bg-rose-500/10 text-rose-200";
}

export default function ReadinessChip({
    label, score, status, testId, hint,
}) {
    if (typeof score === "number") {
        const cls = scoreColor(score);
        return (
            <div
                title={hint || label}
                className={`rounded-md border px-2.5 py-1.5 text-[11px] flex items-center justify-between gap-2 ${cls}`}
                data-testid={testId}
            >
                <span className="font-medium">{label}</span>
                <span className="tabular-nums font-semibold">{score}</span>
            </div>
        );
    }
    const meta = STATUS_STYLES[status] || STATUS_STYLES.blocked;
    const Icon = meta.icon;
    return (
        <div
            title={hint || meta.label}
            className={`rounded-md border px-2 py-1 text-[11px] flex items-center gap-1.5 ${meta.cls}`}
            data-testid={testId}
        >
            <Icon className="w-3 h-3" />
            <span className="font-medium">{label}</span>
        </div>
    );
}
